export function nomeCookiePostHog(apiKey: string): string {
  return `ph_${apiKey}_posthog`;
}

export function montarDominiosPais(hostname: string): string[] {
  const partes = (hostname || '').split('.').filter(Boolean);
  const dominios: string[] = [];
  for (let i = 1; i <= partes.length - 2; i++) {
    dominios.push('.' + partes.slice(i).join('.'));
  }
  return dominios;
}

export function limparCookiePostHogLegado(
  apiKey: string,
  doc?: Document,
  hostname?: string
): void {
  try {
    const documento = doc ?? (typeof document !== 'undefined' ? document : undefined);
    const host = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');
    if (!apiKey || !documento) {
      return;
    }
    const cookieName = nomeCookiePostHog(apiKey);
    const expirado = 'Thu, 01 Jan 1970 00:00:00 GMT';
    for (const dominio of montarDominiosPais(host)) {
      documento.cookie = `${cookieName}=; expires=${expirado}; path=/; domain=${dominio}`;
    }
  } catch {
    void 0;
  }
}
